import { config, crFetch, handlers } from '_helpers';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.orionAPI;

async function getAll(accountID) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'GET',
        url: `/machineMinePlans?accountID=${accountID}`,
      },
      API
    )
  );
}

async function getById(mineplaID, machineID) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'GET',
        url: `/machineMinePlans/${mineplaID}/${machineID}`,
      },
      API
    )
  );
}

async function create(mineplan) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'POST',
        url: '/machineMinePlans',
        body: mineplan,
        multipart: true,
      },
      API
    )
  );
}

async function update(mineplan) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'PUT',
        url: '/machineMinePlans',
        body: JSON.stringify(mineplan),
      },
      API
    )
  );
}

async function bulkactivation(machineMinePlans) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'PUT',
        url: '/machineMinePlans/bulkactivation',
        body: JSON.stringify(machineMinePlans),
      },
      API
    )
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function del(minePlanID, machineID) {
  return handleResponseAsync(
    await crFetch(
      {
        method: 'DELETE',
        url: `/machineMinePlans/${minePlanID}/${machineID}`,
      },
      API
    )
  );
}

const machineMinePlanService = {
  getAll,
  getById,
  create,
  update,
  del,
  bulkactivation,
};

export default machineMinePlanService;
